export function Audio() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" data-name="Group 5802" viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path">
          <path fill="#fff" d="M0 0H24V24H0z" data-name="Rectangle 345"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 15">
        <g data-name="Group 7305" transform="translate(-132 -10)">
          <text
            fill="#0070b6"
            data-name=""
            fontFamily="jiomoney"
            fontSize="20"
            letterSpacing=".3em"
            transform="translate(134 29)">
            <tspan x="0" y="0">
              
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  )
}
